import React from 'react';
import Icon from '../Icons/Icon';
import 'idempotent-babel-polyfill';

export default class CategorySelectBlock extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			resources: props.resources
		}
	}

	createCategoryBlock(CategoryBlock, i) {
		let categoryID = {
		    categoryID: CategoryBlock.code
		}
		let categoryCrumb = this.props.breadcrumbsList.filter(c => c.CategoryID == CategoryBlock.code);
		let ActiveClass = categoryCrumb.length > 0 ? 'category-name active' : 'category-name';
		return(
			<div key={i} className="main-category-wrapper clearfix" role="row">
				<div className={ActiveClass} role="rowheader">
					<a role="treeitem" href="javascript:void(0);" title={CategoryBlock.description} onClick={this.props.SearchCategories.bind(this, categoryID)}>{CategoryBlock.description}</a>
				</div>
				<div className="category-wrapper clearfix" id={CategoryBlock.code} role="tree">
					{CategoryBlock.items.map(this.createCategoryList.bind(this))}
				</div>
			</div>
		)
	}

	createCategoryList(category, i){
		let categoryID = {
			categoryID: category.code
		}
		let categoryCrumb = this.props.breadcrumbsList.filter(c => c.CategoryID == category.code);
		let ActiveClass = categoryCrumb.length > 0 ? 'subcategory-name active' : 'subcategory-name';
        if (category.items.length > 0)
            return (
              	<div key={i} className="subcategory-wrapper clearfix" role="row">
                    <div className={ActiveClass} role="rowheader">
				        <a role="treeitem" href="javascript:void(0);" title={category.description}  onClick={this.props.SearchCategories.bind(this, categoryID)}>{category.description}</a>
                    </div>
                    <div role="tree" className="sub-subcategory-wrapper clearfix">
				    {category.items.map(this.createCategoryList.bind(this))}
                    </div>
			    </div>
            );
        else
		    return(
			    <div key={i} className="sub-subcategory-wrapper clearfix" role="row">
                    <div className={ActiveClass} role="rowheader" >
				        <a role="treeitem" href="javascript:void(0);" title={category.description}  onClick={this.props.SearchCategories.bind(this, categoryID)}>{category.description}</a>
                    </div>
			    </div>
		    );
    }

	render(){
		return(
			<div className="category-select-block">
				<div className="category-select-section">
					{/*<a className="category-select-section-title active" href="#category-select-1">{this.state.resources["PWS.CategoryArea.CategoryListCategoryTitle"]}</a>*/}

					<div id="cateogory-select-1" className="category-select-section-content clearfix open" style={{display: 'block'}}>
						<div className="categories-wrapper clearfix" role="tree">
							{this.props.CategoryList.map(this.createCategoryBlock.bind(this))}
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/CategorySelectBlock.js